import { Component, OnInit } from '@angular/core';
import { faTags, faPercent, faTicketAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-discounts',
  templateUrl: './discounts.component.html',
  styleUrls: ['./discounts.component.scss'],
  host: { 'class': 'wrapper-discounts' }
})
export class DiscountsComponent implements OnInit {
  faTags = faTags
  faPercent = faPercent
  faTicketAlt = faTicketAlt

  constructor() {
  }

  ngOnInit(): void {

  }
}
